import React, { useEffect, useState } from "react";
import { ClickAwayListener } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface IStick {
    Filters?: JSX.Element;
    children?: React.ReactNode;
    active?: boolean;
    inicialyOpenned?: boolean;
    icon?: IconProp;
}
export default function StickyToolbar(props: IStick) {
    useEffect(() => {
        if (props.inicialyOpenned && !props.active) {
            setTimeout(() => {
                setShow("offcanvas-on");
            }, 250);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [show, setShow] = useState("");

    return (
        <>
            <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 mt-4">
                <li
                    className="nav-item "
                    id="kt_demo_panel_toggle"
                    data-toggle="tooltip"
                    title="Filtros"
                    data-placement="right"
                    data-original-title="Filtros"
                >
                    <button
                        className={`btn btn-sm btn-icon ${
                            !props.active
                                ? " btn-bg-light btn-icon-primary"
                                : "btn-bg-success"
                        } btn-hover-primary`}
                        onClick={() => {
                            setShow("offcanvas-on");
                        }}
                    >
                        <FontAwesomeIcon
                            icon={props.icon ?? faFilter}
                            color={props.active ? "white" : undefined}
                        />
                    </button>
                </li>
            </ul>
            <ClickAwayListener
                mouseEvent="onMouseDown"
                touchEvent="onTouchEnd"
                onClickAway={() => {
                    setShow("");
                }}
            >
                <div
                    id="kt_demo_panel"
                    className={`offcanvas offcanvas-right p-10 ${show}`}
                >
                    <div
                        className="offcanvas-header d-flex align-items-center justify-content-between pb-7"
                        kt-hidden-height="47"
                    >
                        <h4 className="font-weight-bold m-0">Filtros</h4>
                        <button
                            className="btn btn-xs btn-icon btn-light btn-hover-primary"
                            id="kt_demo_panel_close"
                            onClick={() => {
                                setShow("");
                            }}
                        >
                            <i className="ki ki-close icon-xs text-muted"></i>
                        </button>
                    </div>
                    <div className="offcanvas-content">
                        <div
                            className="offcanvas-wrapper mb-5 y-scroll pr-2"
                            style={{ height: "90vh" }}
                        >
                            {props.Filters ?? props.children}
                        </div>
                        <div
                            className="offcanvas-footer"
                            kt-hidden-height="38"
                        ></div>
                    </div>
                </div>
            </ClickAwayListener>
        </>
    );
}
